"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findSelfIntersections = findSelfIntersections;
var _computeBbox = require("./computeBbox");
var _intersectEntities = require("./intersectEntities");
var _BoundingBoxIntersector = require("./BoundingBoxIntersector");
/**
 * Finds points of intersection between the entities
 * @param contour A contour, containing an array of entities
 */
function findSelfIntersections(contour) {
  // TODO: An arc and a line, or two arcs, that are consecutive, could still potentially intersect like this:
  /*
         _____  
        /     \
  _____/_______\
      |
       \
  */
  // Do we really want to test every pair of consecutive entities for this? (It will be quick to see whether a supposed intersection is actually an endpoint.)

  const intersectingPoints = [];
  const intersector = new _BoundingBoxIntersector.BoundingBoxIntersector(contour.entities, e => (0, _computeBbox.computeBbox)([e]), {
    ignoreAdjacentCollisions: true,
    wrapAround: contour.isClosed
  });
  for (let intersection of intersector.getIntersections()) {
    let e1 = intersection[0].item;
    let e2 = intersection[1].item;

    // Add entities to the list of intersection points
    intersectingPoints.push(...(0, _intersectEntities.intersectEntities)(e1, e2).map(({
      point,
      t1,
      t2
    }) => ({
      point,
      t1,
      t2,
      entity1: e1,
      entity2: e2
    })));
  }
  return intersectingPoints;
}